import { gsap } from "gsap";
import { Texture } from "pixi.js";

import { AbstractView } from "../../../../../abstracts/modules/AbstractView";
import { playSound, stopAmbSounds } from "../../../../../abstracts/utils/SoundUtils";
import { UgliestCatch } from "../../../../UgliestCatch";
import { UCSoundNames } from "../../../../assetsLoader/UCAssetsNames";
import { UCGameData, UCInitData } from "../../../../types/UCInterfaces";
import { UCFreespinIntroScreen } from "./UCFreespinIntroScreen";

export class UCFreespinRestoreScreen extends UCFreespinIntroScreen {
    constructor(parentContainer: AbstractView, name: string = `UCFreespinRestoreScreen`) {
        super(parentContainer, name);
    }

    protected override getScreenCustomName(): string {
        return `Freespin Restore`;
    }

    protected override getTextureName(): string {
        return `FS_INTRO`;
    }

    protected getFsLeftDefaultText(): string {
        return `Freespins ${UgliestCatch.apiPlugin.translations.translate(`Left`)}:`;
    }

    public override getGsapAnimation(fsLeft: number = 0): gsap.core.Timeline {
        const gameData: UCInitData | UCGameData = UgliestCatch.model.data,
            spinsLevel: number = gameData.extraPositionsOpen.filter((item) => item).length;

        this.fsLeftText.updateValue(`${fsLeft}`);

        this.spinsTextSprite.texture = Texture.from(fsLeft === 1 ? `spinText` : `spinsText`);
        this.spinsTextSprite.visible = true;

        this.spinsNameSprite.texture = Texture.from(this.getSpinsName(spinsLevel));
        this.spinsNameSprite.visible = true;

        const tl = gsap.timeline({ autoRemoveChildren: true });

        const showScreenTween = gsap.fromTo(
            this,
            { alpha: 0 },
            {
                alpha: 1,
                duration: 0.01,
                onStart: () => {
                    this.addChild(this.continueButton);
                    this.backgroundSpine.getSpineTween(`Loop`, true);

                    playSound({ name: this.getIntroStartSoundName() });
                    playSound({ name: this.getIntroLoopSoundName(), repeat: -1 });
                    stopAmbSounds();
                },
            }
        );

        tl.add(showScreenTween);

        return tl;
    }

    protected getIntroStartSoundName(): string {
        return UCSoundNames.FS_INTRO_START;
    }

    protected getIntroLoopSoundName(): string {
        return UCSoundNames.FS_INTRO_LOOP;
    }
}
